// extracted by mini-css-extract-plugin
module.exports = {"container":"Mypage_container__1ZLIh","hash":"Mypage_hash__15bgv","myvalue_container":"Mypage_myvalue_container__2_VkF"};